import { useState } from "react";
import { Container } from "react-bootstrap";
import { Crossword, SliderCrucigrama } from "../../components";

export const CrosswordPage = () => {
  const [activeCrucigramaId, setActiveCrucigramaId] = useState(null);

  return (
    <Container>
      <SliderCrucigrama
        activeCrucigramaId={activeCrucigramaId}
        setActiveCrucigramaId={setActiveCrucigramaId}
      />
      <Crossword crucigramaId={activeCrucigramaId} />
    </Container>
  );
};
